/**
 * Enhanced Card Component
 * Glass card with depth and animations
 */

import { ComponentProps, forwardRef } from 'react'
import clsx from 'clsx'

interface CardProps extends ComponentProps<'div'> {
  variant?: 'default' | 'elevated' | 'interactive'
  padding?: 'none' | 'sm' | 'md' | 'lg'
  hover?: boolean
}

const Card = forwardRef<HTMLDivElement, CardProps>(({
  variant = 'default',
  padding = 'md',
  hover = false,
  children,
  className = '',
  ...props
}, ref) => {
  const baseStyles = `
    glass-card
  `
  
  const variantStyles = {
    default: '',
    elevated: 'glass-card-elevated',
    interactive: `
      cursor-pointer
      transition-all duration-300
      hover:transform hover:scale-[1.02]
      active:scale-[0.99]
    `,
  }
  
  const paddingStyles = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }
  
  const hoverStyles = hover ? `
    transition-all duration-300
    hover:shadow-xl
    hover:border-white/20
  ` : ''
  
  return (
    <div
      ref={ref}
      className={clsx(
        baseStyles,
        variantStyles[variant],
        paddingStyles[padding],
        hoverStyles,
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
})

Card.displayName = 'Card'

export default Card
